package playground.gradient.ui.components

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.snap
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import androidx.compose.ui.BiasAlignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import kotlin.math.absoluteValue


@Composable
fun Slider(
    modifier: Modifier = Modifier,
    value: Float = 0f,
    setValue: (Float) -> Unit = {},
) {


    val setValueState = rememberUpdatedState(setValue)

    var localValue by remember { mutableStateOf(value) }

    LaunchedEffect(value) {
        delay(100)
        localValue = value
    }
    LaunchedEffect(localValue) {
        setValue(localValue)
    }

    var isDragging by remember { mutableStateOf(false) }
    val animatedLocalValue by animateFloatAsState(
        targetValue = localValue,
        animationSpec = if (isDragging)
            snap() else
            spring(
                stiffness = Spring.StiffnessLow,
                dampingRatio = Spring.DampingRatioLowBouncy,
            ),
        visibilityThreshold = .0001f
    )

    var width by remember { mutableStateOf(0) }
    var overshoot by remember { mutableStateOf(0f) }
//    var value by remember { mutableStateOf(0f) }
    val horizontalBias by remember {
        derivedStateOf {
            (animatedLocalValue * 2f) - 1f
        }
    }

    val animatedOvershoot by animateFloatAsState(
        targetValue = overshoot,
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessLow,
        )
    )

    Box(
        modifier
            .onSizeChanged { width = it.width }
            .pointerInput(Unit) {
                var rawValue = 0f
                detectHorizontalDragGestures(
                    onDragStart = {
                        rawValue = localValue
                        isDragging = true
                    },
                    onDragEnd = {
                        overshoot = 0f
                        isDragging = false
                    },
                    onHorizontalDrag = { change, dragAmount ->

                        rawValue += (dragAmount / width)
                        var newValue = rawValue
//                        newValue += (dragAmount / width)
                        println("$localValue -> $newValue")
                        if (newValue > 1f || newValue < 0f) {
                            val coercedValue = newValue.coerceIn(0f, 1f)
                            overshoot = (overshoot + (rawValue * .01f)) //newValue - coercedValue
                            newValue = coercedValue
                        } else {
                            overshoot = 0f
                        }
                        localValue = newValue
                    }
                )
            }
            .graphicsLayer {
                translationX = animatedOvershoot * 30
                transformOrigin = TransformOrigin(
                    when {
                        animatedOvershoot < 0f -> 0f
                        animatedOvershoot > 1f -> 1f
                        else -> 0.5f
                    },
                    0.5f
                )
//                scaleX = 1f - animatedOvershoot.absoluteValue * .1f
                scaleY = 1f - animatedOvershoot.absoluteValue * .03f
            }
//            .offset { IntOffset((overshoot * 30).roundToInt(), 0) }
            .fillMaxWidth()
            .height(48.dp)
            .background(
                color = Color.White.copy(alpha = .12f),
                shape = CircleShape,
            )
    ) {
        Box(
            Modifier
                .align(BiasAlignment(horizontalBias, 0f))
//                .offset {
//                    IntOffset((value * width).roundToInt(), 0)
//                }
                .aspectRatio(1f)
                .fillMaxHeight()
                .background(
                    color = Color.White,
                    shape = CircleShape
                )
        )
    }

}


@Composable
fun OldSlider(
    modifier: Modifier = Modifier,
    value: Float = 0f,
    setValue: (Float) -> Unit = {},
) {

//    androidx.compose.material.Slider(
//        value = value,
//        onValueChange = setValue
//    )
//    return

    val setValueState = rememberUpdatedState(setValue)

    var localValue by remember { mutableStateOf(value) }

    LaunchedEffect(value) {
        delay(100)
        localValue = value
    }
    LaunchedEffect(localValue) {
        setValue(localValue)
    }

    var isDragging by remember { mutableStateOf(false) }
    val animatedLocalValue by animateFloatAsState(
        targetValue = localValue,
        animationSpec = if (isDragging)
            snap() else
            spring(
                stiffness = Spring.StiffnessLow,
                dampingRatio = Spring.DampingRatioLowBouncy,
            ),
        visibilityThreshold = .0001f
    )

    var width by remember { mutableStateOf(0) }
    var overshoot by remember { mutableStateOf(0f) }
//    var value by remember { mutableStateOf(0f) }
    val horizontalBias by remember {
        derivedStateOf {
            (animatedLocalValue * 2f) - 1f
        }
    }

    val animatedOvershoot by animateFloatAsState(
        targetValue = overshoot,
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessLow,
        )
    )

    Box(
        modifier
            .onSizeChanged { width = it.width }
            .pointerInput(Unit) {
                detectHorizontalDragGestures(
                    onDragStart = {
                        isDragging = true
                    },
                    onDragEnd = {
                        overshoot = 0f
                        isDragging = false
                    },
                    onHorizontalDrag = { change, dragAmount ->
                        var newValue = localValue
                        newValue += (dragAmount / width)
                        println("$localValue -> $newValue")
                        if (newValue > 1f || newValue < 0f) {
                            val coercedValue = newValue.coerceIn(0f, 1f)
                            overshoot += newValue - coercedValue
                            newValue = coercedValue
                        } else {
                            overshoot = 0f
                        }
                        localValue = newValue
                    }
                )
            }
            .graphicsLayer {
                translationX = animatedOvershoot * 30
                transformOrigin = TransformOrigin(
                    when {
                        animatedOvershoot < 0f -> 0f
                        animatedOvershoot > 1f -> 1f
                        else -> 0.5f
                    },
                    0.5f
                )
//                scaleX = 1f - animatedOvershoot.absoluteValue * .1f
                scaleY = 1f - animatedOvershoot.absoluteValue * .03f
            }
//            .offset { IntOffset((overshoot * 30).roundToInt(), 0) }
            .fillMaxWidth()
            .height(48.dp)
            .background(
                color = Color.White.copy(alpha = .12f),
                shape = CircleShape,
            )
    ) {
        Box(
            Modifier
                .align(BiasAlignment(horizontalBias, 0f))
//                .offset {
//                    IntOffset((value * width).roundToInt(), 0)
//                }
                .aspectRatio(1f)
                .fillMaxHeight()
                .background(
                    color = Color.White,
                    shape = CircleShape
                )
        )
    }

}